export const SidebarContent = [
  { id: "movements", name: "Movements" },
  { id: "sales", name: "Sales" },
  { id: "inventory", name: "Inventory" },
]
